import {useState, useMemo} from 'react';
import {useLocation} from 'react-router-dom';
//import Menu from '../../components/Menu';
//import SignIn from '../../components/SignIn';
import Footer from '../../components/MFooter'
//import Header from '../../components/Header';

import FormInput from '../../components/FormInput';
import {Error} from '../../components/Erro';
import { Link } from 'react-router-dom';
import useForm from '../../hooks/useForm';
import useAuth from '../../hooks/useAuth';

import {LoadingV2} from '../../components/Loading';
import './login.css';

function useQuery() {
  const { search } = useLocation();
  // return search
  return useMemo(() => new URLSearchParams(search), [search]);
}

function Login () {

  const { values, handleChange } = useForm({
      initialValues: {
          email: '',
          password: '',
          url : useQuery().get("to")
      }
  });

  const { loginUser, error } = useAuth(); //

  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
      e.preventDefault();
      setLoading(true)
      await loginUser(values);
      setLoading(false)
  }
  return (
    <div id="login-home">
      {!!loading && <PopUP/>}
      {/*<Header />*/}
      <div id='login-page'>
        <section className="block">
          <div className="wrapper-login">
            <h2 className="title">Fazer login</h2>
            <div className="Form__notif">
                {!!error && <Error error={error.messages}/>}
            </div>

            <form className="section-sign-in" onSubmit={handleLogin}>
              <div className="form-group form-icon form-login">
                <FormInput type={"email"}
                  id= {"email"}
                  placeholder= {"Insira o seu e-mail"}
                  name= {"email"}
                  value= {values.email.toLowerCase()}
                  handleChange= {handleChange}
                  autoComplete = {"email"}
                  className = {"form-input form-icon--user"}
                />
                <label className="form-label-input">{"E-mail:"}</label>
              </div>
              <div className="form-group form-icon form-login">
                <FormInput type={"password"}
                  id= {"senhaUsuario"}
                  placeholder={"Insira sua senha"}
                  name={"password"}
                  value={values.password}
                  handleChange={handleChange}
                  autoComplete ={"current-password"}
                  className={"form-input form-icon-lock"}
                  />
                <label className="form-label-input">{"Senha:"}</label>
              </div>

               <div className = {"esqueceu" /*dj-blink*/}>
                 <Link to='/EsqueceuSenha'>
                     <h5 className="form-link-senha"> Esqueci minha senha </h5>
                 </Link>
               </div>

              <button className="btn-default btn-light djbtn" type="submit">
                  <h4>Acessar</h4>
              </button>
            </form>
          </div>
        </section>

        <section className="block-gradient calltoaction">
          <div className="wrapper-login djbtn">
            <h2 className="title-cadastre-se">Não tem conta?</h2>
            <a className="cadastre-se" href="/Cadastrar"><b>Cadastre-se</b></a>
          </div>
        </section>

        <div className="w">
        </div>

      </div>

      <Footer/>

    </div>
  );
}

export default Login;


function PopUP(){
    return (
        <div className='pop-up-load2'>
            <div className='pop-up-load2-conteiner'>
                <LoadingV2 texto='Conectando ao servidor'/>
            </div>
        </div>
    )
}
